import { SEND_MESSAGE_RECEIVE, SEND_MESSAGE_GROUPS_RECEIVE, CONVERSATION_UPDATE_UNREAD_STATUS_SUCCESS } from '../actions/communication';
import { updateAccountPlayers } from '../actions/partner';

let queryClient = null;

export const setQueryClient = (client) => {
  queryClient = client;
};

export const communicationQueryMiddleware = store => next => action => {
  const result = next(action);

  if (action.type === SEND_MESSAGE_RECEIVE || action.type === SEND_MESSAGE_GROUPS_RECEIVE) {
    if (queryClient) {
      queryClient.invalidateQueries({ queryKey: ['conversation'] });
    }
  }

  if (action.type === CONVERSATION_UPDATE_UNREAD_STATUS_SUCCESS) {
    if (queryClient) {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
    }
    if (store.getState().accountPlayers.length > 0) {
      store.dispatch(updateAccountPlayers({}));
    }
  }

  return result;
};
